import { Check } from "lucide-react";

const ComfortSection = () => {
  return (
    <section className="py-20 px-4 bg-acg-charcoal text-primary-foreground">
      <div className="container mx-auto text-center">
        <h2 className="text-4xl md:text-5xl font-black mb-4 uppercase tracking-wide">Comfort in Winter & Summer</h2>
        <p className="text-xl md:text-2xl text-primary-foreground/80 mb-10 font-semibold">
          Efficient Air Conditioning with Performance that Lasts the Seasons
        </p>
        <ul className="flex flex-col md:flex-row items-center justify-center gap-8">
          {[
            "The Latest Technology in the Market",
            "Economical, Smooth & Efficient",
            "Competitive Prices Across All Products",
          ].map((item) => (
            <li key={item} className="flex items-center gap-3 text-lg font-semibold">
              <Check className="w-6 h-6 text-acg-green flex-shrink-0" />
              {item}
            </li>
          ))}
        </ul>
        <p className="mt-8">
          <a href="/ac-types" className="text-acg-green hover:underline font-semibold text-lg">
            Compare split, ducted & multi-head AC system types
          </a>
        </p>
      </div>
    </section>
  );
};

export default ComfortSection;
